// extracted by mini-css-extract-plugin
export var activeDot = "_6r-c";
export var buttonContainer = "_6r-9";
export var channelButton = "_6r-a";
export var clickable = "_6r-d";
export var content = "_6r-0";
export var contentFull = "_6r-2";
export var contentThird = "_6r-1";
export var contentWrapper = "_6r-7";
export var description = "_6r-5";
export var heightShort = "_6r-f";
export var image = "_6r-3";
export var imageContainer = "_6r-4";
export var selectButton = "_6r-e";
export var spinnerContainer = "_6r-b";
export var titleContent = "_6r-8";
export var titleWrapper = "_6r-6";